export default "__VITE_ASSET__CP4loV3G__"